import { BookOpen, BriefcaseBusiness, HeartPulse, Route } from 'lucide-react';

export const campaignThemes = [
  { label: 'Mais Educação', icon: BookOpen },
  { label: 'Mais Saúde', icon: HeartPulse },
  { label: 'Mais Infraestrutura', icon: Route },
  { label: 'Mais Oportunidades', icon: BriefcaseBusiness },
] as const;
